import saltConversionCalculator from '../modules/salt-conversion-calculator';

export default {
  init() {
    // JavaScript to be fired on the single Kitchen Product Post Type
    saltConversionCalculator.init();
  },
  finalize() {
    // JavaScript to be fired on the home page, after the init JS
  },
};



// WEBPACK FOOTER //
// /private/var/www/Morton-Windsor/wp-content/themes/morton-salt/resources/assets/scripts/multisite/routes/singleKitchenProduct.js